export default "__VITE_ASSET__CeXLuGUs__"